import { requestIntensity } from "@/shared/utils/axios.ts"
import { useMutation } from "@tanstack/react-query"

export async function markAsReadNotification(id: number) {
  return await requestIntensity.post(`/energy-audit-notifications/${id}/mark-as-read`)
}

export const useMarkAsReadNotification = () => {
  return useMutation({
    mutationFn: markAsReadNotification
  })
}
